export function createSlug(text) {
  return text
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.replace(/[^\w\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/g, '-')
    ?.toLowerCase()
}
